export default __webpack_public_path__ + "static/media/92.c835a0fc.jpeg";